export default {
  name: 'ClientPicker',
  props: {
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showlabel: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    withRegistryNumber: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      content: this.value,
      itemOptions: null,
      searchTxt: '',
      currentReq: null
    };
  },
  computed: {
    hasAnyResults () {
      return this.itemOptions && this.searchTxt && this.searchTxt.length > 0 && this.itemOptions.length === 0;
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.content);
      this.$emit('changed', this.content);
    },
    searchFocus () {
      if (this.content === null) {
        this.searchItem(this.searchTxt)
      }
    },
    searchItem () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.content = null;
      this.updateValue();
      const self = this;
      const search = this.searchTxt.trim();
      if (search.length > 2) {
        setTimeout(
          function () {
            if (search === self.searchTxt.trim()) {
              self.loading = true;
              self.currentReq = self.ApiRequest.request('client/find?qry=' + encodeURIComponent(search) + '&withRegistryNumber=' + parseInt(self.withRegistryNumber), self.ApiRequest.REQUEST_GET, [], function (response) {
                if (response.data) {
                  self.itemOptions = response.data;
                  self.loading = false;
                }
              });
            }
          }, 500);
      } else {
        this.loading = false;
        self.itemOptions = null;
      }
    },
    getItemText (item) {
      let res = '';
      if (item) {
        res = item.name;
        if (this.withRegistryNumber) {
          res += ' (' + item.registryNumber + ')';
        }
      }
      return res
    },
    selectItem (item) {
      this.searchTxt = this.getItemText(item);
      this.content = item;
      this.updateValue();
      this.itemOptions = null;
      this.loading = false;
    },
    clearSearch () {
      this.itemOptions = null;
      this.searchTxt = '';
      this.content = null;
      this.loading = false;
      this.updateValue();
    },
    editElement (refName, element) {
      this.$refs[refName].show(element);
    }
  },
  mounted () {
    this.searchTxt = this.getItemText(this.content);
  }
}
